import { Flex } from '@/components/atoms/Grid'
import {
  forwardRef,
  memo,
  useEffect,
  useImperativeHandle,
  useState
} from 'react'
import { ProductSize, PromoCode } from '@/network/graphql.g'
import { SelectLayoutType } from '@/components/molecules/select'
import useTranslation from 'next-translate/useTranslation'
import { SelectSizes } from '@/components/molecules/selectSizes'

type SizesPickerProps = {
  sizes: ProductSize[]
  initialSelectedSizeId?: string
  onDidSelectSize: (id: ProductSize) => void
  productId: string
  promoCodes: PromoCode[]
} & Rest

export type SizesPickerActions = {
  setSizeId: (sizeId: string) => void
  getSizeId: () => string
}

const ProductDetailSizesPicker = forwardRef<
  SizesPickerActions,
  SizesPickerProps
>((props, ref) => {
  const { sizes, initialSelectedSizeId, onDidSelectSize, promoCodes, ...rest } =
    props
  const [sizeId, setSizeId] = useState<string>(initialSelectedSizeId)

  const { t } = useTranslation('common')
  useEffect(() => {
    onDidSelectSize(sizes.find((item) => item.id === sizeId))
  }, [sizeId])
  useImperativeHandle(ref, () => ({
    setSizeId: (sizeId) => {
      setSizeId(sizeId)
    },
    getSizeId: () => sizeId
  }))

  return (
    <>
      <Flex
        flexDirection="row"
        width="100%"
        height={43}
        justifyContent="stretch"
        {...rest}
      >
        <SelectSizes
          width="100%"
          placeholder={t('ProductDetail.Sizes.chooseSize')}
          emptyValue={t('ProductDetail.Sizes.chooseSize')}
          selectedIndex={sizes.findIndex(({ id }) => id === sizeId)}
          items={sizes.map(({ id, value, isStock }) => ({
            title: value.toUpperCase(),
            id,
            isStock
          }))}
          onSelect={(id) => setSizeId(id as string)}
          layoutType={SelectLayoutType.arrowAtEnd}
          promoCodes={promoCodes}
        />
      </Flex>
    </>
  )
})

export default memo(ProductDetailSizesPicker)
